/* Account.js */

import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
// import AppBar1 from '../../components/commom/AppBar1';
import Footer1 from '../../components/commom/Footer1';
import UserAccount from '../../components/user/UserAccount';
import UserChangeEmail from '../../components/user/UserChangeEmail';
import UserPassword from '../../components/user/UserPassword';
import Strings from '../../translations/Translations';
import UserCredits from '../../components/credits/UserCredits/UserCredits';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';

export default function Account() {
  return (
    <>
      <AppBar2 />

      <Container fluid className='my-4'>
        <Row className='mb-2'>
          <Col sm={12}>
            <h1 className='h3'>
              {Strings('account')}
            </h1>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <UserCredits />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Row className='mb-4'>
              <Col>
                <Card className='shadow-lg border-0'>
                  <CardBody>
                    <UserAccount />
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row className='mb-4'>
              <Col>
                <Card className='shadow-lg border-0'>
                  <CardBody>
                    <UserChangeEmail />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col>
                <Card className='shadow-lg border-0'>
                  <CardBody>
                    <UserPassword />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <Footer1 />
    </>
  );
}
